import { Center, Progress } from "@mantine/core";

export default function LoadingScreen() {
  return (
    <Center h="100%">
      <Progress animated striped maw="32rem" radius="xl" value={100} w="80%" />
    </Center>
  );
}
